// Картата на едно разделяне на телефон. Общата транспозиция „ред на колона"
// би направила от седем колони карта от седем реда — тук първият ред носи
// това, което човек търси: откъде накъде е местено и за колко.

import { ArrowRightOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import { fmtEuro } from "../../../../utils/currency";
import { EM_DASH, formatDateTime } from "../../../../components/dataTable";
import type { SplitRow } from "./billsSplitsMath";

type Props = {
  row: SplitRow;
  /** Периодът е повече от един ден — датата се показва до часа. */
  isMultiDay: boolean;
};

export const BillsSplitsMobileCard = ({ row, isMultiDay }: Props) => {
  const { t } = useTranslation();
  const moment = formatDateTime(row.split_date, isMultiDay);

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-2">
        <span className="flex min-w-0 flex-1 items-center gap-1.5">
          <span className="truncate rounded-md bg-brand-tint px-2 py-[3px] text-[12px] font-bold leading-[normal] text-brand-deep-ink">
            {row.from_bill_name}
          </span>
          <ArrowRightOutlined
            aria-hidden
            className="shrink-0 text-[11px] text-muted"
          />
          <span className="truncate rounded-md bg-brand-tint px-2 py-[3px] text-[12px] font-bold leading-[normal] text-brand-deep-ink">
            {row.to_bill_name}
          </span>
        </span>
        <span className="shrink-0 font-pos-mono text-[15px] font-bold tabular-nums text-ink">
          {fmtEuro(row.amount)}
        </span>
      </div>

      <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[12px] font-medium text-muted">
        <span className="font-pos-mono tabular-nums">{moment.time}</span>
        {moment.date ? (
          <span className="font-pos-mono tabular-nums">{moment.date}</span>
        ) : null}
        <span aria-hidden>·</span>
        <span className="truncate">{row.waiterLabel || EM_DASH}</span>
        <span aria-hidden>·</span>
        <span className="font-pos-mono tabular-nums">
          {`${row.itemsCount} ${t("reportsPage.products").toLowerCase()}`}
        </span>
      </div>

      {row.comment ? (
        <p className="m-0 truncate text-[12px] font-medium text-soft">
          {row.comment}
        </p>
      ) : null}
    </div>
  );
};
